export default __webpack_public_path__ + "static/media/powerExperienceIcon3.9d09ba33.webp";